import { d as __assign, h as __values, g as __spread, a as __extends, _ as __makeTemplateObject } from './chunk-525a49bc.js';
import { Collapse } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { d as defaultTheme, w as withDefaultTheme, b as withAssetFiles } from './chunk-2f6aabaf.js';
import { s as sortStringsAlphabetically } from './chunk-5dec4ccb.js';

// Copyright 2020 Cognite AS
var docTypes = {
    AA: 'Accounting',
    AB: 'Administration (Project management)',
    AF: 'Templates – used by contractor (not economic documentation)',
    CA: 'Analysis, tests and calculations',
    DS: 'Data sheets',
    FA: 'Project manual, e.g. principal decisions',
    FB: 'Project strategy',
    FD: 'Project design criteria',
    FE: 'Engineering query',
    FQ: 'Concession requests',
    GA: 'Authorities documentation',
    HA: 'Hazop actions.',
    IR: 'Interface report',
    KA: 'Procedures',
    KH: 'Commissioning procedures',
    KY: 'System operation procedures',
    KZ: 'System description',
    LA: 'Lists, registers and indexes',
    LC: 'User manual content lists',
    LD: 'Supplier master document/information registers',
    LF: 'Legends and typical',
    MA: 'Equipment user manual, including technical descriptions',
    MB: 'Operation and maintenance instructions/manuals',
    MC: 'Parts and Spare parts lists',
    MG: 'Equipment handling instructions',
    MH: 'Lubrication schedules',
    MZ: 'Overall Life Cycle Information (LCI)',
    OT: 'Training Documentation, Course Material',
    QA: 'Technical Query',
    SI: 'Site instructions',
    SQ: 'Site Query',
    PA: 'Purchase order',
    PB: 'Blanket order and frame agreements',
    PC: 'Call off orders',
    PD: 'Contracts',
    PJ: 'Material handling reports',
    PE: 'Commercial Bid Evaluation for Budget Inquiry',
    PK: 'Over, shortage and damage reports',
    PG: '(Hold) Appendix E Technical Requisition',
    PH: 'Technical Bid Evaluation',
    PM: 'Evaluation Matrix',
    PN: 'Inquiry Documents (Procurement)',
    PO: 'Bid Opening and Shortlisting Report',
    PR: 'Recommendation for Award',
    PS: 'Package Procurement Strategy',
    PT: 'Screening',
    PV: 'Pre-Qualification Questionnaire',
    PQ: 'Invitation to Tender (Budget)',
    PX: 'Budget Inquiry',
    PZ: 'Technical Bid Evaluation for Budget Inquiry ',
    PL: 'Disputed variation order',
    RA: 'Reports – not covered by other codes',
    RB: 'Risk analysis reports',
    RC: 'Non-conformance reports',
    RD: 'System and design reports',
    RE: 'Design Fabrication Installation-resumes',
    RF: 'Verification reports',
    RG: 'Application for Deviation',
    RH: 'Deviation report',
    RK: 'Application for Exemption (Deviation require authority approval) ',
    RS: 'Studies Reports',
    SA: 'Standards (amendment to Norsok)',
    SP: 'Specifications - not covered by other codes',
    TA: 'Plans and schedules',
    TB: 'Work plans',
    TD: 'Cable and cable transit schedules',
    TE: 'Estimates',
    TF: 'Work packages',
    TG: 'Spring schedules',
    TR: 'Transmittal',
    VA: 'Manufacturing and verifying document, including material traceability, weld and Non- Destructive Examination (NDE) doc, third party verification and also photos of submerged structures and equipment.',
    VD: 'Fabrication records (see DN02-DN-Z-KA-0003 ch 5.152) ',
    VB: 'Certificates',
    VM: 'Mechanical completion and commissioning dossiers',
    WM: 'Inspection and maintenance isometrics',
    WN: 'Inspection videos',
    XA: 'Flow diagrams',
    XB: 'P&ID',
    XC: 'D&ID',
    XD: 'General arrangements',
    XE: 'Layout drawings',
    XF: 'Location drawings and plot plans',
    XG: 'Structural information, including main structural steel, second/outfitting steel, structural fire protection and acoustic/thermal insulation and fire protection',
    XH: 'Free span calculations structural information, secondary steel',
    XI: 'System topology, block diagrams and SCD',
    XJ: 'Single line diagrams',
    XK: 'Circuit diagrams',
    XL: 'Logic diagrams',
    XM: 'Level diagrams',
    XN: 'Isometric drawings, including fabrication, heat tracing. NOTE: This code is replaced by codes starting with "Y". Drawings already issued with code "XN" may not be reissued.',
    XO: 'Pipe supports',
    XP: 'Termination drawings for external connections ',
    XQ: 'Pneumatic/hydraulic connection drawings',
    XR: 'Cause and effects',
    XS: 'Detail cross sectional drawings',
    XT: 'Wiring diagrams',
    XU: 'Loop diagrams',
    XV: 'Structural information, outfitting steel',
    XW: 'Stress isometric',
    XX: 'Miscellaneous drawings',
    XY: 'Hook up drawings',
    XZ: 'Material Selection Datasheet (MSD)',
    YA: 'Design isometric ',
    YB: 'Fabrication isometric ',
    YC: 'Heat trace isometric ',
    YD: 'Nodal diagram',
    ZA: 'EDP-documentation general',
    ZB: 'Software documentation',
    ZC: 'System documentation',
    ZD: 'VDU-pictures',
    ZE: 'Graphical reports from 3D Computer Aided Design (CAD) models',
    ZF: '3D CAD view models',
};

var maxDocumentTitleLength = 56;
var documentTypesOptions = ['DOC_TYPE', 'doc_type'];
var documentTitleOptions = ['DOC_TITLE', 'title'];
var getPriorityObjectFromArray = function (list) {
    return list.reduce(function (acc, p, i) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[p] = i + 1, _a)));
    }, {});
};
var sortDocsByPriority = function (a, b, priority) {
    return ((priority[a] || Number.MAX_SAFE_INTEGER) -
        (priority[b] || Number.MAX_SAFE_INTEGER));
};
var getValueFromObject = function (metadata, arr) {
    if (!metadata || !arr) {
        return '';
    }
    var data = objKeysToLowerCase(metadata);
    return arr.reduce(function (acc, name) {
        if (!acc) {
            return data[name.toLowerCase()]
                ? data[name.toLowerCase()].toString()
                : '';
        }
        return acc;
    }, '');
};
var objKeysToLowerCase = function (obj) {
    return obj
        ? Object.keys(obj).reduce(function (acc, key) {
            acc[key.toLowerCase()] = obj[key];
            return acc;
        }, {})
        : {};
};
var getDocumentType = function (metadata, documentTypeField) {
    var names = documentTypeField ? [documentTypeField] : documentTypesOptions;
    return getValueFromObject(metadata, names);
};
var getCategoryName = function (keyList, unknownCategoryName, types) {
    if (unknownCategoryName === void 0) { unknownCategoryName = 'Unknown document type'; }
    if (types === void 0) { types = docTypes; }
    var key = keyList.find(function (item) { return !!types[item]; }) || '';
    return {
        key: key,
        description: types[key] || unknownCategoryName,
    };
};
var getCategoryByPriority = function (docsByCat, priorityList, customSort) {
    var e_1, _a;
    if (priorityList === void 0) { priorityList = []; }
    var priorityObject = getPriorityObjectFromArray(priorityList);
    var prioritizedCategories = [];
    var regularCategories = [];
    try {
        for (var _b = __values(Object.keys(docsByCat)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var category = _c.value;
            if (priorityObject[category] !== undefined) {
                prioritizedCategories.push(category);
            }
            else {
                regularCategories.push(category);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var sortFunction = customSort || sortStringsAlphabetically;
    return {
        categories: prioritizedCategories
            .sort(function (a, b) { return sortDocsByPriority(a, b, priorityObject); })
            .concat(regularCategories.sort(function (a, b) {
            return sortFunction(docsByCat[a].description, docsByCat[b].description);
        })),
        prioritizedCount: prioritizedCategories.length,
    };
};
var getDocumentsByCategory = function (docs, unknownCategoryName, types, documentTypeField) {
    if (types === void 0) { types = docTypes; }
    return docs.reduce(function (acc, doc) {
        var _a;
        var keyList = __spread([
            getDocumentType(doc.metadata, documentTypeField)
        ], doc.name.split('-'));
        var _b = getCategoryName(keyList, unknownCategoryName, types), key = _b.key, description = _b.description;
        var documents = acc[key] ? acc[key].documents : [];
        return __assign(__assign({}, acc), (_a = {}, _a[key] = __assign(__assign({}, acc[key]), { description: description, documents: __spread(documents, [doc]) }), _a));
    }, {});
};
var getDocumentTitle = function (metadata, documentTitleField) {
    var names = documentTitleField
        ? [documentTitleField]
        : documentTitleOptions;
    return getValueFromObject(metadata, names);
};
var getShortDescription = function (description) {
    return description.length > maxDocumentTitleLength
        ? description.substring(0, maxDocumentTitleLength) + "..."
        : description;
};

var Panel = Collapse.Panel;
var DocumentTable = /** @class */ (function (_super) {
    __extends(DocumentTable, _super);
    function DocumentTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderDocument = function (category, description) { return function (document, i, all) {
            var documentRenderer = _this.props.documentRenderer;
            if (documentRenderer) {
                return documentRenderer(document, i, all);
            }
            var _a = _this.props, documentTitleField = _a.documentTitleField, handleDocumentClick = _a.handleDocumentClick, styles = _a.styles;
            return (React.createElement(LinkContainer, { key: document.id, style: styles && styles.fileContainer },
                React.createElement(LinkStyle, { key: document.id, "data-test-id": "file-name", onClick: function () {
                        return handleDocumentClick
                            ? handleDocumentClick(document, category, description)
                            : null;
                    }, tabIndex: -1, style: styles && styles.fileLink }, document.name),
                React.createElement(TextContainerTop, { "data-test-id": "document-title", style: styles && styles.fileTitle }, getDocumentTitle(document.metadata, documentTitleField))));
        }; };
        return _this;
    }
    DocumentTable.prototype.render = function () {
        var _this = this;
        var _a = this.props, assetFiles = _a.assetFiles, categoryPriorityList = _a.categoryPriorityList, unknownCategoryName = _a.unknownCategoryName, documentTypeField = _a.documentTypeField, docTypes = _a.docTypes, noDocumentsSign = _a.noDocumentsSign, collapseProps = _a.collapseProps, customCategorySort = _a.customCategorySort, styles = _a.styles;
        var documentsByCategory = getDocumentsByCategory(assetFiles || [], unknownCategoryName, docTypes, documentTypeField);
        var _b = getCategoryByPriority(documentsByCategory, categoryPriorityList, customCategorySort), categories = _b.categories, prioritizedCount = _b.prioritizedCount;
        if (!categories.length) {
            return (React.createElement(NoDocuments, { "data-test-id": "no-documents" }, "" + (noDocumentsSign
                ? noDocumentsSign
                : 'No documents linked to this asset')));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(TableWrapper, null,
                React.createElement(CollapseContainer, __assign({}, collapseProps), categories.map(function (category, i) {
                    var _a = documentsByCategory[category], description = _a.description, documents = _a.documents;
                    var header = getShortDescription(description) + " (" + documents.length + ")";
                    return (React.createElement(PanelWrapper, { header: header, key: category, delimiter: prioritizedCount === i + 1 &&
                            prioritizedCount !== categories.length, style: styles && styles.wrapper }, documents.map(_this.renderDocument(category, description))));
                })))));
    };
    DocumentTable.defaultProps = {
        handleDocumentClick: function () { return null; },
        categoryPriorityList: ['XB', 'XL'],
        theme: __assign({}, defaultTheme),
    };
    return DocumentTable;
}(React.PureComponent));
var TableWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  justify-content: center;\n  display: flex;\n"], ["\n  width: 100%;\n  justify-content: center;\n  display: flex;\n"])));
var LinkContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  margin: 10px 0;\n  white-space: nowrap;\n"], ["\n  display: flex;\n  margin: 10px 0;\n  white-space: nowrap;\n"])));
var CollapseContainer = styled(Collapse)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var TextContainerTop = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-transform: uppercase;\n"], ["\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-transform: uppercase;\n"])));
var PanelWrapper = styled(Panel)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  text-align: left;\n  ", "\n"], ["\n  text-align: left;\n  ",
    "\n"])), function (_a) {
    var delimiter = _a.delimiter;
    return delimiter ? 'border-bottom: 2px solid #CFCFCF !important;' : '';
});
var LinkStyle = styled.a(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: 1.125em;\n  margin-right: 10px;\n"], ["\n  font-size: 1.125em;\n  margin-right: 10px;\n"])));
var NoDocuments = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  padding: 16px;\n"], ["\n  padding: 16px;\n"])));
var Component = withDefaultTheme(DocumentTable);
Component.displayName = 'DocumentTable';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

// Copyright 2020 Cognite AS
var AssetDocumentsPanel = withAssetFiles(Component);

export { AssetDocumentsPanel as A, Component as C, getCategoryByPriority as a, getDocumentsByCategory as b, getDocumentTitle as c, getShortDescription as d, getCategoryName as g };
